import React from "react";

import Card from "../ui/Card";

function ChartCard({
  title,
  subtitle = "",
  children,
  height = 360,
}) {
  return (
    <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, overflow: "hidden" }}>
      <Card title={title} width="full">
        {subtitle && (
          <div style={{ marginBottom: "12px", opacity: 0.7 }}>
            {subtitle}
          </div>
        )}

        <div style={{ width: "100%", maxWidth: "100%", minWidth: 0, height, overflow: "hidden" }}>
          {children}
        </div>
      </Card>
    </div>
  );
}

export default ChartCard;